import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();

import {getParameterByName} from '../utils/tools';

import {getOriginProjectData} from '../lib/service';
import {removeUrlProtocal} from '../utils/tools';
import {getHomeworkInfo} from '../lib/homework-info';
// import analytics from '../lib/analytics';
import log from '../lib/log';

import {
    openLoadingProject,
    closeLoadingProject
} from '../reducers/modals';
import storage from '../lib/storage';

import scratchTester from "../lib/scratch-tester/index";

/**
 * Project loader component passes a file input, load handler and props to its child.
 * It expects this child to be a function with the signature
 *     function (renderFileInput, loadProject, props) {}
 * The component can then be used to attach project loading functionality
 * to any other component:
 *
 * <ProjectLoader>{(renderFileInput, loadProject, props) => (
 *     <MyCoolComponent
 *         onClick={loadProject}
 *         {...props}
 *     >
 *         {renderFileInput()}
 *     </MyCoolComponent>
 * )}</ProjectLoader>
 */

const messages = defineMessages({
    loadError: {
        id: 'gui.projectLoader.loadError',
        defaultMessage: 'The project file that was selected failed to load.',
        description: 'An error that displays when a local project file fails to load.'
    }
});

class ProjectLoader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'renderFileInput',
            'setFileInput',
            'handleChange',
            'handleClick',
            'reloadProject',
            'handleNextStudy',
            'testSB3'
        ]);
        this.arr = [];
        this.errorNum = 0;
        this.timeOutNum = 20000;
        this.testIndex = 0;
        this.testErrorMessage= '';
        this.timeoutObj = null;
        window.nextStudy = window.nextStudy || this.handleNextStudy;
        this.state = {
            loadingError: false,
            errorMessage: ''
        };
    }
    componentDidMount () {
        this.homeworkInfo = getHomeworkInfo();
        this.courseId = Number(this.homeworkInfo.courseId);
        this.unitId = Number(this.homeworkInfo.unitId);
        this.lessonId = Number(this.homeworkInfo.lessonId);
    }
    handleNextStudy (){
        let that = this;
        clearTimeout(that.timeoutObj);
        this.timeoutObj = null;
        //this.testErrorMessage += `/n OK: ${that.testIndex};`;
        this.testIndex++;
        this.testSB3();
    }
    testSB3(){
        let that = this;
        let arr = this.arr;
            if(that.testIndex < arr.length){
                that.props.openLoadingState();
                    fetch(arr[that.testIndex], { method: 'GET', headers: { Accept: 'application/octet-stream' } })
                    .then(response => response.blob())
                    .then(blob => that.props.vm.loadProject(blob))
                    .then(() => {
                        that.props.closeLoadingState();
                        setTimeout(() => {
                            that.props.vm.greenFlag();
                        },1000);
                        that.timeoutObj = setTimeout(() => {
                            that.props.vm.stopAll();
                            that.errorNum += 1;
                            that.testErrorMessage += `\n^^run timeout(${that.timeOutNum/1000}s) : ${that.testIndex}; ${arr[that.testIndex]}`;
                            that.testIndex++;
                            that.testSB3();
                        }, that.timeOutNum);
                    })
                    .catch(error => {
                        that.props.closeLoadingState();
                        //alert(`${arr[this.testIndex]} Failed!`)
                        that.errorNum += 1;
                        that.testErrorMessage += `\n##load failed : ${that.testIndex}; ${arr[that.testIndex]}`;
                        that.testSB3(that.testIndex++);
                        //window.confirm('file loaded failure' + i); // eslint-disable-line no-alert
                        //log.error(error);
                    });
            }else{
                console.clear();
                console.log(`共测试${that.testIndex}个SB3, 失败${that.errorNum}个`,that.testErrorMessage);
                //testErrorMessage
                that.arr = [];
                that.errorNum = 0;
                that.testIndex = 0;
        }
    }
    handleChange (e) {
        // Remove the hash if any (without triggering a hash change event or a reload)
        //history.replaceState({}, document.title, '.');
        const reader = new FileReader();
        const thisFileInput = e.target;
        const file0 = e.target.files[0];
        const that = this;
        this.timeOutNum = (Number(getParameterByName('time'))*1000)||20000;
        if(file0.name.endsWith('.txt')){
            reader.readAsText(file0);
            reader.onload = function(event) {
               let txt = event.target.result.trim();
               let arr = txt.split('\n');
               const arr1 = arr.map(x => x.trim());
               that.arr = arr1;
               that.testErrorMessage = '';
               that.testSB3();
            }
        } else {
            // eslint-disable-next-line no-alert
            if (window.confirm('打开本地作品后，现在的作品将被覆盖')) {
                this.props.vm.loadProject(thisFileInput.files[0])
                    .then((zip) => zip && scratchTester.loadProject(zip))
                    .then(() => {
                        ht.track('s3_open_localfile', {
                            context: {
                                courseId: this.courseId,
                                unitId: this.unitId,
                                lessonId: this.lessonId,
                                currentUrl: location.href,
                                stageDisplayMode: localStorage.getItem('stageDisplayMode')
                            }
                        });
                        // analytics.event({
                        //     category: 'project',
                        //     action: 'Import Project File',
                        //     nonInteraction: true
                        // });
                        this.props.closeLoadingState();
                        // Reset the file input after project is loaded
                        // This is necessary in case the user wants to reload a project
                        thisFileInput.value = null;
                    })
                    .catch(error => {
                        log.warn(error);
                        alert(this.props.intl.formatMessage(messages.loadError)); // eslint-disable-line no-alert
                        this.props.closeLoadingState();
                        // Reset the file input after project is loaded
                        // This is necessary in case the user wants to reload a project
                        thisFileInput.value = null;
                    });
                if (thisFileInput.files) { // Don't attempt to load if no file was selected
                    this.props.openLoadingState();
                }
            } else {
                thisFileInput.value = null;
            }
        }
    }
    handleClick () {
        if (this.props.mode === 'reload') {
            this.reloadProject();
            return;
        }
        this.fileInput.click();
    }
    setFileInput (input) {
        this.fileInput = input;
    }
    renderFileInput () {
        return (
            <input
                accept=".sb2,.sb3,.txt"
                ref={this.setFileInput}
                style={{display: 'none'}}
                type="file"
                onChange={this.handleChange}
            />
        );
    }
    reloadProject () {
        // eslint-disable-next-line no-alert
        if (window.confirm('确定要重做吗？现在的作品将被覆盖')) {
            const homeworkInfo = getHomeworkInfo();
            const courseId = homeworkInfo.courseId;
            const unitId = homeworkInfo.unitId;
            const lessonId = homeworkInfo.lessonId;
            this.props.openLoadingState();
            let projectUrl = null;
            if (this.props.url !== '') {
                projectUrl = this.props.url;
            }
            ht.track('s3_redo', {
                context: {
                    courseId: this.courseId,
                    unitId: this.unitId,
                    lessonId: this.lessonId,
                    currentUrl: location.href,
                    stageDisplayMode: localStorage.getItem('stageDisplayMode')
                }
            });
            const goAhead = () => {

                projectUrl = removeUrlProtocal(projectUrl);

                if (projectUrl === null) {
                    storage
                        .load(storage.AssetType.Project, 0, storage.DataFormat.JSON)
                        .then(projectAsset => this.props.vm.loadProject(projectAsset.data))
                        .then((zip) => zip && scratchTester.loadProject(zip))
                        .then(() => this.props.closeLoadingState())
                        .catch(err => log.error(err));
                } else {
                    const opts = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/octet-stream'
                        }
                    };
                    fetch(projectUrl, opts)
                        .then(response => response.blob())
                        .then(blob => this.props.vm.loadProject(blob))
                        .then((zip) => zip && scratchTester.loadProject(zip))
                        .then(() => this.props.closeLoadingState())
                        .catch(error => {
                            this.props.closeLoadingState();
                            window.confirm('file loaded failure' + error.message); // eslint-disable-line no-alert
                            log.error(error);
                        });
                }


            };
            if (unitId !== '' || courseId !== '' || lessonId !== '') {
                getOriginProjectData(courseId, lessonId, unitId).then(
                    data => {
                        projectUrl = data.originProjectUrl;
                    }
                )
                    .catch()
                    .finally(goAhead);
                return;
            }
            goAhead();


        }
    }
    render () {
        if (this.state.loadingError) {
            throw new Error(
                `Failed to load project from file: ${this.state.errorMessage}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            children,
            closeLoadingState,
            openLoadingState,
            vm,
            /* eslint-enable no-unused-vars */
            ...props
        } = this.props;
        if (this.props.mode === 'reload') {
            return this.props.children(this.handleClick);
        }
        return this.props.children(this.renderFileInput, this.handleClick, props);
    }
}

ProjectLoader.propTypes = {
    children: PropTypes.func,
    closeLoadingState: PropTypes.func,
    intl: intlShape.isRequired,
    mode: PropTypes.string,
    openLoadingState: PropTypes.func,
    url: PropTypes.string,
    vm: PropTypes.shape({
        loadProject: PropTypes.func
    })
};

const mapStateToProps = state => ({
    url: state.scratchGui.homework.url,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    closeLoadingState: () => dispatch(closeLoadingProject()),
    openLoadingState: () => dispatch(openLoadingProject())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(ProjectLoader));
